export default __webpack_public_path__ + "static/media/eye_icon.ed62dd55.svg";